import { getEls, createJsOverlay } from "./helpers.js";
import EventListeners from "./EventListeners.js";
import OptinMonster from "./OptinMonster.js";

var HeaderSection = new Object();

HeaderSection.version = "1.0.0";

HeaderSection.init = function () {
  // return;

  var { elMain, elTopSection } = getEls();

  EventListeners.init();

  var elAdminBarHeight = document.querySelector("body > #wpadminbar");
  var adminBarHeight = elAdminBarHeight ? elAdminBarHeight.offsetHeight : 0;

  // console.log('elAdminBarHeight', elAdminBarHeight);

  elMain.style.setProperty("--header-top-pos", `${adminBarHeight}px`);
  elMain.style.setProperty("--top-section-height", "0");
  elMain.style.setProperty("--top-section-actual-height", `${elTopSection.offsetHeight}px`);

  createJsOverlay();
  elMain.setAttribute("data-initialized", "1");

  OptinMonster.init();
};

// Gate on the actual .header-sections element rather than the body class.
// Parent theme's page-templates/blank.php (e.g. /client-privacy-policy/)
// emits a bare <body> with no body classes, so the previous
// `!hasClass('page-builder-blank-template')` check let init() run and
// then crashed in getEls() when .header-sections wasn't in the DOM.
DOMReady(() => {
  if (document.querySelector(".header-sections")) HeaderSection.init();
});
